import {
  Avatar,
  Box,
  Container,
  Flex,
  Grid,
  GridItem,
  Heading,
  Icon,
  Text,
} from '@chakra-ui/react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';
import { animated as a, useSpring } from 'react-spring';
import { StarIcon } from '@chakra-ui/icons';
import { generate } from 'shortid';
import { graphql } from 'gatsby';
import { useMeasure } from 'react-use';
import {
  Blob1,
  Blob2,
  Blob3,
  Blob4,
} from '../components/flare/shapes';
import FlareGroup4 from '../assets/shapes/shape-group-4.svg';
import GoogleG from '../assets/Google__G__Logo.svg';
import BBB from '../assets/Ab-bbb-seal-a.svg';
import {
  CalloutPhoneNumber,
  CardOne,
  HalfByHalfSection,
  SEO,
} from '../components/_index';

const seoContent = {
  title: "See our customer reviews - [We're #1 For A Reason]",
  description:
    'We Buy Houses in . We are a local home buying company in and we pay cash for houses. "Sell my house without cleaning or repairing or paying closing costs!"',
};

const HeroContent = () => (
  <>
    <Heading
      as="h1"
      size="4xl"
      lineHeight="base"
      mb={4}
    >
      <span className="highlight">
        See What Our Customers are Saying
      </span>
    </Heading>
  </>
);

const FlareBlock = ({ img }) => (
  <Box
    zIndex="0"
    height={{ base: '20rem', md: '25rem' }}
  >
    <Box
      transform={{ base: 'scale(.8)', md: 'scale(1)' }}
      position="relative"
      width="20rem"
      mx="auto"
      height="15rem"
    >
      <Box
        position="relative"
        mt={4}
      >
        <Box
          position="absolute"
          top={{ base: '0%', md: '-20%' }}
          left="-30%"
        >
          <FlareGroup4 className="width-400 height-500 width-md-500 height-md-500" />
        </Box>
        <Box
          position="absolute"
          top={{ base: '0%', md: '-20%' }}
          left="20%"
        >
          <GatsbyImage
            className="width-300"
            alt="happy home buyers image"
            image={img}
          />
        </Box>
      </Box>
    </Box>
  </Box>
);

const ReviewsSection = ({ data }) => {
  return (
    <Container maxW="container.xl">
      <Grid
        templateColumns="repeat(6, 1fr)"
        gap={12}
        mx="auto"
      >
        {data.googleReviews.nodes.map((r, i) => (
          <GridItem
            id={`/#${r.googlePlacesId}`}
            colSpan={{ base: 6, md: 3 }}
            key={generate()}
            width={{ base: '100%' }}
          >
            <CardOne
              width={{ base: '100%' }}
              p={{ base: 6, md: 10 }}
            >
              <Box
                mb={3}
                display="flex"
                alignItems="center"
              >
                <Box mr={2}>
                  <GoogleG />
                </Box>
                {Array.from({ length: r.rating }, () => 0).map(
                  (j) => (
                    <Icon
                      key={generate()}
                      as={StarIcon}
                      boxSize={6}
                      color="yellow.300"
                    />
                  ),
                )}
              </Box>
              <Text
                mb={4}
                fontSize="lg"
                as="em"
              >
                {r.text}
              </Text>
              <Flex
                alignItems="center"
                mt={4}
              >
                <Avatar
                  size="lg"
                  name={`Google profile of ${r.author_name}`}
                  src={r.profile_photo_url}
                />
                {' '}
                <Heading
                  as="h6"
                  variant="sec"
                  size="sm"
                  ml={2}
                  mb={0}
                >
                  -
                  {' '}
                  {r.author_name}
                </Heading>
              </Flex>
            </CardOne>
          </GridItem>
        ))}
      </Grid>
    </Container>
  );
};

const ReviewsPage = ({ data, location }) => {
  const flare = getImage(data.heroImage);
  useEffect(() => {
    if (location.hash) {
      const timer = setTimeout(() => {
        const scrollPositionInit = window.scrollY;
        const offSet = window.innerHeight / 4;
        const test = scrollPositionInit - offSet;

        window.scrollTo({
          top: test,
          left: 0,
        });
      }, 900);
      return () => clearTimeout(timer);
    }

    // Logs `HTMLInputElement`
  }, []);
  return (
    <main>
      <SEO
        location={location}
        title={seoContent.title}
        description={seoContent.description}
      />
      <Container maxW="container.xl">
        <HalfByHalfSection
          pt={20}
          left={<HeroContent />}
          right={<FlareBlock img={flare} />}
        />
      </Container>
      <Container
        maxW="container.xl"
        // marginTop="-300px"
        display="flex"
        flexWrap="wrap"
        justifyContent="space-around"
        alignItems="center"
      >
        <Box width="300px">
          <GatsbyImage
            alt="Google five star"
            image={
              data.googleFiveStarImg.childImageSharp.gatsbyImageData
            }
          />
        </Box>
        <Box width="300px">
          <BBB className="width-300" />
        </Box>
      </Container>
      <ReviewsSection data={data} />
      <CalloutPhoneNumber />
    </main>
  );
};

export const query = graphql`
  query {
    googleReviews: allGooglePlacesReview {
      nodes {
        author_url
        author_name
        googlePlacesId
        rating
        profile_photo_url
        time
        relative_time_description
        text
        id
      }
    }
    googleFiveStarImg: file(
      relativePath: { eq: "Google-5-Star.png" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
    heroImage: file(
      relativePath: { eq: "people/working-together.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
  }
`;

export default ReviewsPage;
